// extracted by mini-css-extract-plugin
export default {"principle-card":"PrincipleCard_principle-card__yK4VV","icon":"PrincipleCard_icon__50nr6","description":"PrincipleCard_description__oZw3X"};